// src/i18n.ts
import { createI18n } from 'vue-i18n';

export type AppLocale = 'de' | 'en';

export function detectInitialLocale(): AppLocale {
  const saved = (sessionStorage.getItem('language') || localStorage.getItem('language')) as AppLocale | null;
  const browser = navigator.language.split('-')[0];
  if (saved === 'de' || saved === 'en') return saved;
  return browser === 'de' || browser === 'en' ? (browser as AppLocale) : 'de';
}

const i18n = createI18n({
  legacy: false, // Composition API verwenden
  locale: detectInitialLocale(), // Startsprache
  fallbackLocale: 'en',
  messages: {}, // wir laden gleich lazy
  missingWarn: true,
  fallbackWarn: true,
  // Im Dev-Modus fehlende Keys sichtbar machen:
  postTranslation: (str, key) => (import.meta.env.DEV && str === key ? `⟦${key}⟧` : str),
});

export default i18n;
